import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Player } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { DataService } from '../../data.service';
import { NavigationLibraryService } from '../../shared/services/navigation/navigation.service';
import { RoutingService } from '../../shared/services/routing/routing.service';
import { StorefrontService } from '../../storefront/storefront.service';
import { PlayerDialogData } from '../interfaces/dialogs.interface';
import { openPlayerEpisodesDialog, openPlayerSubtitlesDialog } from '../player-dialogs';

@Component({
  selector: 'app-player-options',
  templateUrl: './player-options.component.html',
  styleUrls: ['./player-options.component.scss'],
})
export class PlayerOptionsComponent implements OnInit {
  @Input() playerInstance: Player;
  @Input() currentResource: ResourceVm;
  @Input() currentTime: number;
  @Output() hideControls = new EventEmitter<boolean>();
  @Output() openEPGDialog = new EventEmitter<void>();
  @Input() showSubtitles = false;
  @Input() isLive = false;
  @Input() isAd = false;
  resourceVmUpNext: ResourceVm;
  constructor(
    private dialog: MatDialog,
    private navService: NavigationLibraryService,
    private readonly storefrontService: StorefrontService,
    private readonly routingService: RoutingService,
    private dataService: DataService,
    private readonly translateService: TranslateService
  ) {
    //
  }

  ngOnInit(): void {
    this.getUpNextResource();
  }

  get isLiveEvent(): boolean {
    return this.currentResource?.contentType === 'liveevent';
  }

  openEpg(): void {
    this.hideControls.emit(true);
    this.openEPGDialog.emit();
  }

  openSubtitlesMenu(): void {
    this.hideControls.emit(true);
    openPlayerSubtitlesDialog(this.dialog, this.getDialogData()).then(() => {
      this.hideControls.emit(false);
    });
  }

  openEpisodes(): void {
    this.hideControls.emit(true);
    openPlayerEpisodesDialog(this.dialog, this.getDialogData()).then(() => {
      this.hideControls.emit(false);
    });
  }

  async suggestedNextClick(): Promise<void> {
    await this.routingService.navigateToPlayerWithValidations(this.resourceVmUpNext, false);
    this.dataService.playbackStartTime = new Date().getTime();
  }

  /**
   * Update index manually since mat dialog set focus auto
   * Update user activity to hide controls
   *
   * @param index
   */
  focusOption(index: number): void {
    this.navService.setHorizontalIndex(index);
    this.navService.setVerticalIndex(3);
  }

  /**
   * Handle mouse enter in div to magic remote
   *
   * @param event
   * @param index
   */
  mouseEnterOptions(event: MouseEvent, index: number): void {
    this.navService.setIndexContainer('player-options', index);
    this.navService.focusElement(event.target as HTMLElement, index, false ? 2 : 3);
  }

  private getDialogData(): PlayerDialogData {
    return {
      player: this.playerInstance,
      currentResource: this.currentResource,
      dialogDescription: this.translateService.instant('player.subtitles'),
      currentTime: this.currentTime,
    };
  }

  private async getUpNextResource(): Promise<void> {
    if (this.currentResource.type.includes('episode') || this.currentResource.type.includes('serie')) {
      this.storefrontService
        .fetchUpNextContent(
          this.currentResource.seriesId,
          this.currentResource.contentGenre,
          this.currentResource.contentType,
          this.currentResource.providerName,
          this.currentResource.seasonNumber,
          this.currentResource.episodeNumber
        )
        .then(async (result: ResourceVm) => {
          if (result.seriesId !== this.currentResource.seriesId) {
            this.resourceVmUpNext = null;
          } else {
            this.resourceVmUpNext = result;
          }
        });
    }
  }
}
